module.exports = __webpack_public_path__ + "img/video-recorder-off.9ca828bc.svg";